<div @fadeInOut class="message-wrapper" *ngIf="displayedMessage">
  <div class="message-caption">
    <img *ngIf="!isError" class="message-state-icon" src="assets/icons/icon-check.svg" alt="success"/>
    <img *ngIf="isError" class="message-state-icon" src="assets/icons/icon-error-check.svg" alt="error"/>
    <span>{{displayedMessage}}</span>
  </div>
  <mat-icon class="hide-button" (click)="hideImmediately()">close</mat-icon>
</div>
